var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"app-button--icon",class:[_vm.effect, _vm.hasEffect],attrs:{"data-jest":"app-button--icon"}},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('Icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }